var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteWaterLevel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M8.414 17h7.172a1 1 0 0 1 .79 1.613l-.083.094-3.586 3.586a1 1 0 0 1-1.32.083l-.094-.083-3.586-3.586a1 1 0 0 1 .59-1.7L8.415 17h7.172zM12 8.5c1.359 0 2.121.569 3.162 1.894l.187.238C16.169 11.676 16.624 12 17.5 12c.92 0 1.38-.28 2.2-1.176l.187-.204C20.927 9.486 21.687 9 23 9a1 1 0 0 1 0 2c-.61 0-.944.213-1.639.972l-.186.204C20.012 13.444 19.1 14 17.5 14c-1.645 0-2.56-.652-3.724-2.132l-.186-.238c-.694-.883-1.025-1.13-1.59-1.13-.565 0-.896.247-1.59 1.13l-.186.238C9.06 13.348 8.144 14 6.5 14c-1.6 0-2.512-.556-3.675-1.824l-.186-.204C1.944 11.213 1.61 11 1 11a1 1 0 0 1 0-2c1.313 0 2.074.486 3.113 1.62l.187.204C5.12 11.72 5.58 12 6.5 12c.876 0 1.331-.324 2.151-1.368l.187-.238C9.879 9.07 10.64 8.5 12 8.5zm.707-7.793l3.586 3.586A1 1 0 0 1 15.586 6H8.414a1 1 0 0 1-.707-1.707L11.293.707a1 1 0 0 1 1.414 0z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWaterLevel);
export default __webpack_public_path__ + "static/media/white-water-level.1b7bd8c137cc5253141d16e534da5976.svg";
export { ForwardRef as ReactComponent };